module.exports = __webpack_public_path__ + "static/media/01_CORTININHA_SEM_BOJO_LISO_01.6b050f3f.jpg";